import styled from 'styled-components'

export const TooltipHint = styled.span`
  background-image: linear-gradient(to right, #000 75%, transparent 75%);
  background-position: 0 1.04em;
  background-size: 5px 3px;
  background-repeat: repeat-x;
`
